module.exports = __webpack_public_path__ + "static/media/warningShield.9e9c1a23.svg";